(function ($) {
	var halo = {
	    splash: {

            selector: '.splash',
            languageTransition: 500,
            show: false,

            init: function() {
                this.checkVisibility();
                this.setOpeners();
                if(this.show == 'true'){
                    $('html').addClass('halo-modal-open');
                    this.setBehaviors();
                    this.setVisibility(false);
                }

            },
            showModal: function(){
                $(`${this.selector}`).show();
                $('html').addClass('halo-modal-open halo-modal-open--manual');
                this.setBehaviors();
                this.setVisibility(false);
            },
            hideModal: function(){
                $(`${this.selector}`).hide();
                $('html').removeClass('halo-modal-open halo-modal-open--manual');
                this.setVisibility(false);
            },
            setOpeners: function(){
                const   self = this;
                $('body').on('click', `${self.selector}__toggle, [href*="#splash"]`, function(e){
                    e.preventDefault();
                    self.showModal();
                });

                $('body').on('click', `${self.selector}__close`, function(){
                    self.hideModal();
                });
            },
            setBehaviors: function(){
                const   self = this;

                $(`${self.selector}__content`).click(function(e){
                    e.preventDefault();
                    $(this).parents(`${self.selector}__block`).addClass('open').siblings(`${self.selector}__block`).addClass('closed');
                    $(this).parents(`${self.selector}`).addClass('selecting');
                });

                $(`${self.selector}__back`).click(function(e){
                    e.preventDefault();
                    $(`${self.selector}`).removeClass('selecting');
                    $(`${self.selector}__block`).removeClass('open closed');
                });

                $(`${self.selector}__country`).click(function(e){
                    e.preventDefault();
                    $(this).siblings(`${self.selector}__languages`).slideDown(self.languageTransition);
                    $(this).parent('li').addClass('active').siblings().removeClass('active').addClass('hide').find(`${self.selector}__languages`).slideUp(self.languageTransition);
                    $(this).parents(`${self.selector}__nav__content`).addClass('selecting-language');
                });

                $(`${self.selector}__nav__back`).click(function(e){
                    e.preventDefault();
                    $(`${self.selector}__languages`).slideUp(self.languageTransition);
                    $(this).parents(`${self.selector}__nav__content`).removeClass('selecting-language');
                    $(this).parents(`${self.selector}__nav__content`).find('li').removeClass('active hide');
                });
            },
            checkVisibility: function(){
                const show = localStorage.getItem('showSplash');
                this.show = (show === null) ? true : show;
            },
            setVisibility: function(show){
                localStorage.setItem('showSplash', show);
            }

        }
	}
	halo.splash.init();
})(jQuery);
